export default __webpack_public_path__ + "static/media/orange-candy.b822c1d4.png";